import { render, staticRenderFns } from "./StatsSection.vue?vue&type=template&id=10808916&"
import script from "./StatsSection.vue?vue&type=script&lang=js&"
export * from "./StatsSection.vue?vue&type=script&lang=js&"
import style0 from "./StatsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports